import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IAtendente } from 'src/app/interfaces/atendente';

@Injectable({
  providedIn: 'root'
})
export class AtendenteService {
  private readonly baseURL = '/Atendente';
  constructor(private httpClient: HttpClient) {}

  getAtendente() {
    return this.httpClient.post<IApiResponse<IAtendente[]>>(this.baseURL, {});
  }
}
